var _path, _g, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_22",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.046 40 40 31.0457 40 20C40 8.954 31.0457 0 20 0C8.954 0 0 8.9543 0 20C0 31.046 8.9543 40 20 40Z",
    fill: "#EDF0F2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5874 17.9681V14.3H10V17.9681H29.5874Z",
    stroke: "black",
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6694 18.2104V31.1834H29.0832L29.0833 18.8734",
    stroke: "black",
    strokeWidth: 1.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7122 14.3005L19.7122 30.7355",
    stroke: "black",
    strokeWidth: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2106 14.1312L13.4686 11.6404C12.8931 11.1177 12.8317 10.2592 13.326 9.64593V9.64593C13.9313 8.8947 15.093 8.83244 15.7515 9.51594L20.1978 14.1313",
    stroke: "black",
    strokeWidth: 1.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7122 14.3005L24.6425 9.60733C25.2168 9.06061 26.1305 9.01281 26.7479 9.49717V9.49717C27.4303 10.0326 27.4899 11.0069 26.8785 11.6325L24.1956 14.3779",
    stroke: "black",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.0b7267aa3a27c9dee52f91d055baeb27.svg";
export { ForwardRef as ReactComponent };